import {React, useState, useLayoutEffect} from "react";
import styled, { keyframes } from "styled-components";
import headerImg from './img/headerbackground.jpg';




//background: linear-gradient(45deg, ${color1} ${props => props.position1}%, ${color2} ${props => props.position2}%);

const Gradient = keyframes`
  0% { background-position: 0% 50%;}
  50% {background-position: 100% 50%; }
  100% {background-position: 0% 50%; }
`;

const Rotate = keyframes`
   from { --a:0deg;}
  to { --a:360deg;}
`;



const StyledHeader = styled.div`
height: 75vh;
background-image: url(${headerImg});
background-size: cover;
background-position: center;
background-blend-mode: multiply;
width: 100%;
color: white;
font-family: 'Montserrat', sans-serif;
position: relative;
h1{
  position: absolute;
  top: 40%;
  width: 100%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  font-size:3vw;
  opacity: 2;
}
p{
  position: absolute;

  width: 100%;
  top: 55%;
  font-size:2.5vw;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.65)
 
}



span{
  display: inline-block;
  background: -webkit-linear-gradient(45deg,#ff5100 16.66666%,#f5c0b2 33.33333%,#aee8fa 50%,#68bde7 66.66666%,#6bd490 83.33333%,#a2f6cf);
  background-size: 150% 150%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-animation: ${Gradient} 10s ease infinite;
  -moz-animation: ${Gradient} 10s ease infinite;
  animation: ${Gradient} 10s ease infinite, ${Rotate} 10s;
}

@media only screen and (max-width: 1000px) {
  height: 40vh;
    h1{
       
        top: 45%;
        font-size:4vw;   
  }
}

@media only screen and (max-width: 400px) {
  height: 40vh;
  background-position: -80px;
    h1{
       
        top: 45%;
        font-size:6vw;   
  }
}
  
`
const SkillStyling = styled.div`
position: relative;

margin-left: 10px;

span{
  visibility: hidden;
}

::after{
  content: "";
  position: absolute;
  width: 1px;
  height:100%;
  border-right: 4px solid white;

}
`


function Header() {

  const [colorAngel, setColorAngel] = useState(26);
  let [currentSkill, setCurrentSkill] = useState();



const skills = ["Javascript","Python", "Raspberry Pi", "React", "NodeJS","Arduino","Vue",  "Electronics", "Fusion 360", "Adobe"]
let skillCount =0;
let letterCount = 0;
let letter = '';

function typingSkills(){
  
  if(skillCount=== skills.length){
    skillCount=0

  }

  currentSkill =skills[skillCount]
  //console.log( currentSkill )

  letter = currentSkill.slice(0, ++letterCount); // is typing the current skill
  // console.log(letter) 
  setCurrentSkill(letter )

  if(letter.length === currentSkill.length && letterCount >0){ // end of skill end wating 1,2 seconde

    
    setTimeout(()=>{ 
       
    
        //skillCount++;
        letterCount= 0;
        backSpace()
      }, 1400);

  }else {
    setTimeout(typingSkills,230) 
  }
  //console.log(letterCount)
 
}

function backSpace(){
  //console.log("backspace")
  letter = currentSkill.slice(0, --letterCount); // is backspacing the current skill
  setCurrentSkill(letter )
  if(letter.length === 0){
    setTimeout(()=>{ 
      skillCount++;
      letterCount= 0;
      typingSkills()
    },550)
  }else{
    setTimeout(backSpace,130)
  }

  
}

useLayoutEffect(() => {
    
    typingSkills()
       
    const interval = setInterval(() => {
   


     // setColorAngel(counter => counter + 1);
    }, 10);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (

      <StyledHeader colorAngel={colorAngel}  >
    
          <h1>Meet your next <br/> <SkillStyling><span></span>{currentSkill}<span></span> </SkillStyling>
            developer</h1>
    
      </StyledHeader>
  );
}
export default Header;